export function prependHttps(s: string): string {
  if (!!s && !s.match(/^[a-zA-Z]+:\/\//)) {
    return "https://" + s;
  }
  return s;
}
